import React, { useState, useEffect } from "react";
import {
  Modal,
  Box,
  IconButton,
  CircularProgress,
  FormControlLabel,
  Checkbox,
  Backdrop,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import CarePlanPDFView from "./careplanpdf";
import { pdf } from "@react-pdf/renderer";
import axios from "axios";
import ToastMessage from "../../../../../utils/mui/righttoptoast";

const CarePlanDetailModal = ({ open, onClose,type,selectedRecord, loading, data }) => {
  const [formData, setFormData] = useState(null);
const [saveLoading,setSaveLoading]=useState(false)
const isViewMode = type === "view";
  const [openToast, setOpenToast] = useState(false);
  const [toastMessage, setToastMessage] = useState('');
  const [toastSeverity, setToastSeverity] = useState('success');
   const handleToastClose = () => {
    setOpenToast(false);
};
  useEffect(() => {
    if (data) setFormData(data);
  }, [data]);

  const addField = (section, value = "") => {
    setFormData((prev) => ({
      ...prev,
      [section]: [...(prev?.[section] || []), value],
    }));
  };

  const addNestedField = (section, nestedKey, value = "") => {
    setFormData((prev) => ({
      ...prev,
      [section]: {
        ...prev[section],
        [nestedKey]: [...(prev[section]?.[nestedKey] || []), value],
      },
    }));
  };

  const removeField = (section, index) => {
    setFormData((prev) => ({
      ...prev,
      [section]: prev[section].filter((_, i) => i !== index),
    }));
  };

  const removeNestedField = (section, nestedKey, index) => {
    setFormData((prev) => ({
      ...prev,
      [section]: {
        ...prev[section],
        [nestedKey]: prev[section][nestedKey].filter((_, i) => i !== index),
      },
    }));
  };

  const handleChange = (section, index, value) => {
    setFormData((prev) => ({
      ...prev,
      [section]: prev[section].map((v, i) => (i === index ? value : v)),
    }));
  };

  const handleNestedChange = (section, nestedKey, index, value) => {
    setFormData((prev) => ({
      ...prev,
      [section]: {
        ...prev[section],
        [nestedKey]: prev[section][nestedKey].map((v, i) =>
          i === index ? value : v
        ),
      },
    }));
  };
const handlePrint = async () => {
  if (!formData) return;
  const blob = await pdf(<CarePlanPDFView data={formData} />).toBlob();
  const url = URL.createObjectURL(blob);
  const iframe = document.createElement("iframe");
  iframe.style.display = "none";
  iframe.src = url;
  document.body.appendChild(iframe);
  iframe.onload = () => {
    iframe.contentWindow?.print();
  };
};
  const handleInputChange = (field, value) => {
    setFormData((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const handleNestedInputChange = (section, field, value) => {
    setFormData((prev) => ({
      ...prev,
      [section]: {
        ...prev[section],
        [field]: value,
      },
    }));
  };

  const handleCheckboxChange = (field, nestedKey, checked) => {
    setFormData((prev) => ({
      ...prev,
      [field]: {
        ...prev[field],
        [nestedKey]: checked,
      },
    }));
  };
const SaveForm = async () => {
  try {
    setSaveLoading(true)
    const token = localStorage.getItem("auth");

    if (!token) {
      console.error("No auth token found");
      return;
    }

    const response = await axios.post(
      "/v2/bs/patient_care_plan/edit",
      {
        audiolink: selectedRecord.audiolink,
        care_plan: formData,
      },
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );
if(response.status==200){
  setToastMessage('Details Saved Successfully')
  setToastSeverity('success')
  setOpenToast(true)
}else{
    setToastMessage(response?.message||'Something went wrong')
  setToastSeverity('info')
  setOpenToast(true)
}
    console.log("Care plan updated:", response.data);
  } catch (error) {
        setToastMessage('Something went wrong')
  setToastSeverity('info')
  setOpenToast(true)
    console.error("Error updating care plan:", error);
  } finally {
  setSaveLoading(false)
  }
};

  if (loading) {
    return (
      <Modal open={open} onClose={onClose}>
        <Box className="flex justify-center items-center h-[300px] bg-white rounded-xl shadow-2xl p-6">
          <CircularProgress />
        </Box>
      </Modal>
    );
  }

  return (
    <Modal open={open} onClose={onClose}>
      <Box
        className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 
        w-[90%] max-w-5xl bg-white rounded-xl shadow-2xl p-6 overflow-y-auto max-h-[90vh]"
      >
        {/* Close Button */}
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{ position: "absolute", top: 8, right: 8, color: "gray" }}
        >
          <CloseIcon />
        </IconButton>
         <Backdrop
              sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
              open={saveLoading}
            >
              <CircularProgress color="inherit" />
            </Backdrop>
        {/* Header */}
        <div className="text-center border-b-4 border-blue-700 pb-3 mb-6">
          <h1 className="text-2xl font-bold text-blue-700">
            PATIENT-CENTERED CARE PLAN
          </h1>
        </div>

      {/* Print / Save Buttons */}
<div className="mb-4 flex gap-3">
  {!isViewMode && (
    <button
      onClick={() => {
        console.log(formData);
        SaveForm();
      }}
      className="bg-blue-700 hover:bg-blue-800 text-white px-4 py-2 rounded-md"
    >
      Save Form
    </button>
  )}
  {isViewMode && (
    <button
      onClick={handlePrint}
      className="bg-blue-700 hover:bg-blue-800 text-white px-4 py-2 rounded-md"
    >
      Print Care Plan
    </button>
  )}
</div>


        {/* Patient Info */}
        <div className="grid grid-cols-2 gap-4 bg-gray-100 p-4 rounded-lg mb-5">
          <div>
            <label className="font-semibold text-gray-700">Patient Name:</label>
            <input
              type="text"
              value={formData?.patientName || ""}
              readOnly
              className="w-full mt-1 p-2 border border-gray-300 rounded-md"
            />
          </div>
          <div>
            <label className="font-semibold text-gray-700">Date:</label>
            <input
              type="date"
              value={formData?.date || ""}
              readOnly
              className="w-full mt-1 p-2 border border-gray-300 rounded-md"
            />
          </div>
        </div>

      {/* Provider */}
<div className="mb-6">
  <label className="font-semibold text-gray-700">Provider Name</label>
  <input
    type="text"
    value={formData?.providerName || ""}
    onChange={(e) => handleInputChange("providerName", e.target.value)}
    className="w-full mt-1 p-2 border border-gray-300 rounded-md"
      disabled={isViewMode}
  />
</div>

        <p className="font-bold text-green-600 mb-5">
          Complete the next four sections prior to your visit:
        </p>

        {/* Health Concerns */}
        <Section
isViewMode={isViewMode}
  
          title="Top Concerns"
          color="green"
          items={formData?.healthConcerns || []}
          placeholder="Enter main health concern"
          sectionKey="healthConcerns"
          onAdd={addField}
          onChange={handleChange}
          onRemove={removeField}
          buttontext={'+ Add Concern'}
          subtitle={'The main things I would like to fix or improve about my health are:'}
        />

        {/* Health Barriers */}
        <Section
isViewMode={isViewMode}
          title="Health Barriers"
          color="green"
          items={formData?.healthBarriers || []}
          placeholder="Enter barrier to health improvement"
          sectionKey="healthBarriers"
          onAdd={addField}
          onChange={handleChange}
          onRemove={removeField}
           buttontext={'+ Add Barrier'}
          subtitle={'The main things preventing me from improving my health are:'}
        />

        {/* Symptoms */}
        <Section
isViewMode={isViewMode}
          title="Symptom Management"
          color="green"
          items={formData?.symptoms || []}
          placeholder="Enter symptom"
          sectionKey="symptoms"
          onAdd={addField}
          onChange={handleChange}
          onRemove={removeField}
            buttontext={'+ Add Symptom'}
          subtitle={'The main symptoms I wish to reduce or eliminate are:'}
        >
          <p className="text-gray-500 text-sm italic mt-2">
            To treat these, your provider will help you complete the "Summary of
            things I need to do," below, at your appointment.
          </p>
        </Section>

        {/* Other Providers */}
        <Section
isViewMode={isViewMode}
          title="Health Care Providers"
          color="green"
          items={formData?.otherProviders || []}
          placeholder="Enter provider type and name"
          sectionKey="otherProviders"
          onAdd={addField}
          onChange={handleChange}
          onRemove={removeField}
                      buttontext={'+ Add Provider'}
          subtitle={'List any other providers you see regularly for health care (for example, ophthalmologist, cardiologist, therapist):'}
        />

        {/* Support Resources */}
        <Section
isViewMode={isViewMode}
          title="Resources and Supports"
          color="green"
          items={formData?.supportResources || []}
          placeholder="Enter support person or resource"
          sectionKey="supportResources"
          onAdd={addField}
          onChange={handleChange}
          onRemove={removeField}
            buttontext={'+ Add Support'}
          subtitle={'Besides your health care team, who could you turn to for help for health-related problems (for example, family members, friends, a spiritual leader)?'}
        />

        <p className="font-bold text-orange-600 mb-5">
          Complete the remaining sections with your provider at your appointment:
        </p>

        {/* Medications */}
        <Section
isViewMode={isViewMode}
          title="My Medications*"
        color="green"
          items={formData?.medications || []}
          placeholder="Enter medication name, dosage, frequency"
          sectionKey="medications"
          onAdd={addField}
          onChange={handleChange}
          onRemove={removeField}
          buttontext={'+ Add Medication'}
          subtitle={''}
       
        >
          <div className="mt-4 bg-gray-100 p-3 rounded-md">
            <p className="font-bold mb-2">I agree to do the following:</p>
            <FormControlLabel
              control={
                <Checkbox
                  checked={formData?.medicationAgreements?.discussConcerns || false}
                    disabled={isViewMode}
                  onChange={(e) =>
                    handleCheckboxChange(
                      "medicationAgreements",
                      "discussConcerns",
                      e.target.checked
                    )
                  }
                />
              }
              label="Discuss concerns I have about taking any of my medications with my primary care provider (PCP) and/or pharmacist"
            />
            <FormControlLabel
              control={
                <Checkbox
                  checked={formData?.medicationAgreements?.adviseStopping || false}
                    disabled={isViewMode}
                  onChange={(e) =>
                    handleCheckboxChange(
                      "medicationAgreements",
                      "adviseStopping",
                      e.target.checked
                    )
                  }
                />
              }
              label="Advise my PCP if I choose to stop my medication(s), including my reasons for stopping, and discuss potential alternatives"
            />
            <FormControlLabel
              control={
                <Checkbox
                  checked={formData?.medicationAgreements?.adviseSideEffects || false}
                    disabled={isViewMode}
                  onChange={(e) =>
                    handleCheckboxChange(
                      "medicationAgreements",
                      "adviseSideEffects",
                      e.target.checked
                    )
                  }
                />
              }
              label="Advise my PCP of bothersome side effects from my medication(s)"
            />
            <FormControlLabel
              control={
                <Checkbox
                  checked={formData?.medicationAgreements?.informNewMeds || false}
                    disabled={isViewMode}
                  onChange={(e) =>
                    handleCheckboxChange(
                      "medicationAgreements",
                      "informNewMeds",
                      e.target.checked
                    )
                  }
                />
              }
              label="Inform my PCP if new medications are added by other providers"
            />
            <FormControlLabel
              control={
                <Checkbox
                  checked={formData?.medicationAgreements?.reviewedMeds || false}
                    disabled={isViewMode}
                  onChange={(e) =>
                    handleCheckboxChange(
                      "medicationAgreements",
                      "reviewedMeds",
                      e.target.checked
                    )
                  }
                />
              }
              label="I have reviewed the current medication list (see above) and confirm that it is accurate"
            />
          </div>
        </Section>

        {/* Allergies */}
        <Section
isViewMode={isViewMode}
          title="My Allergies*"
      color="green"
          items={formData?.allergies || []}
          placeholder="Enter allergy"
          sectionKey="allergies"
          onAdd={addField}
          onChange={handleChange}
          onRemove={removeField}
            buttontext={'+ Add Allergy'}
          subtitle={''}
        />

        {/* Conditions */}
        <Section
isViewMode={isViewMode}
          title="My Conditions*"
    color="green"
          items={formData?.conditions || []}
          placeholder="Enter medical condition"
          sectionKey="conditions"
          onAdd={addField}
          onChange={handleChange}
          onRemove={removeField}
            buttontext={'+ Add Condition'}
          subtitle={''}
        >
          <div className="mt-4">
            <FormControlLabel
              control={
                <Checkbox
                  disabled={isViewMode}
                  checked={formData?.reviewedConditions || false}
                  onChange={(e) =>
                    handleInputChange("reviewedConditions", e.target.checked)
                  }
                />
              }
              label="I have reviewed my list of conditions"
            />
          </div>
        </Section>

        {/* Treatment Goals */}
        <Section
isViewMode={isViewMode}
          title="Treatment Goals/Targets"
       color="green"
          items={formData?.treatmentGoals || []}
          placeholder="Enter specific, measurable goal"
          sectionKey="treatmentGoals"
          onAdd={addField}
          onChange={handleChange}
          onRemove={removeField}
            buttontext={'+ Add Goal'}
          subtitle={'These are mutually agreed upon, measurable goals...'}
        />

        {/* Summary of Things I Need to Do */}
        <div
          className="border-l-4 pl-4 mb-6 rounded-md border-blue-600 bg-white shadow-sm p-4"
        >
          <h3 className="text-blue-700 font-semibold border-b border-gray-200 pb-1 mb-3">
            Summary of Things I Need to Do
          </h3>
          <p className="text-gray-500 text-sm italic mb-4">
            List action needed and time frame for each item. If not applicable,
            indicate N/A or none:
          </p>
          <div className="grid grid-cols-2 gap-4">
            <Section
isViewMode={isViewMode}
              title="Tests to Complete"
              color="green"
              items={formData?.summary?.tests || []}
              placeholder="Enter test and timeframe"
              sectionKey="summary"
              nestedKey="tests"
              onAdd={addNestedField}
              onChange={handleNestedChange}
              onRemove={removeNestedField}
                  buttontext={'+ Add Test'}
          subtitle={''}
            />
            <Section
isViewMode={isViewMode}
              title="Other Health Professionals to See"
              color="green"
              items={formData?.summary?.professionals || []}
              placeholder="Enter professional and timeframe"
              sectionKey="summary"
              nestedKey="professionals"
              onAdd={addNestedField}
              onChange={handleNestedChange}
              onRemove={removeNestedField}
                    buttontext={'+ Add Professional'}
          subtitle={''}
            />
            <Section
isViewMode={isViewMode}
              title="Community Resources to Use"
              color="green"
              items={formData?.summary?.communityResources || []}
              placeholder="Enter resource and timeframe"
              sectionKey="summary"
              nestedKey="communityResources"
              onAdd={addNestedField}
              onChange={handleNestedChange}
              onRemove={removeNestedField}
                    buttontext={'+ Add Resource'}
          subtitle={''}
            />
            <Section
isViewMode={isViewMode}
              title="Medication Changes to Make"
              color="green"
              items={formData?.summary?.medChanges || []}
              placeholder="Enter change and timeframe"
              sectionKey="summary"
              nestedKey="medChanges"
              onAdd={addNestedField}
              onChange={handleNestedChange}
              onRemove={removeNestedField}
                    buttontext={'+ Add Change'}
          subtitle={''}
            />
            <Section
isViewMode={isViewMode}
              title="Other Treatments to Get"
              color="green"
              items={formData?.summary?.treatments || []}
              placeholder="Enter treatment and timeframe"
              sectionKey="summary"
              nestedKey="treatments"
              onAdd={addNestedField}
              onChange={handleNestedChange}
                    buttontext={'+Add Treatment'}
          subtitle={''}
              onRemove={removeNestedField}
            />
            <Section
isViewMode={isViewMode}
              title="Health-related Education to Pursue"
           color="green"
              items={formData?.summary?.education || []}
              placeholder="Enter education and timeframe"
              sectionKey="summary"
              nestedKey="education"
              onAdd={addNestedField}
              onChange={handleNestedChange}
              onRemove={removeNestedField}
                    buttontext={'+ Add Education'}
          subtitle={''}
            />
          </div>
          <Section
isViewMode={isViewMode}
            title="Short-term Activities to Do"
           color="green"
            items={formData?.summary?.activities || []}
            placeholder="Enter activity and timeframe"
            sectionKey="summary"
            nestedKey="activities"
            onAdd={addNestedField}
            onChange={handleNestedChange}
            onRemove={removeNestedField}
                  buttontext={'+ Add Activity'}
          subtitle={''}
          />
          <div className="mt-4">
            <h4 className="font-semibold text-gray-700">Lifestyle Changes</h4>
            <Section
isViewMode={isViewMode}
              title="Diet"
          color="green"
              items={formData?.lifestyleChanges?.diet || []}
              placeholder="Enter diet change"
              sectionKey="lifestyleChanges"
              nestedKey="diet"
              onAdd={addNestedField}
              onChange={handleNestedChange}
              onRemove={removeNestedField}
                    buttontext={'+ Add Diet Change'}
          subtitle={''}
            />
            <Section
isViewMode={isViewMode}
              title="Exercise"
          color="green"
              items={formData?.lifestyleChanges?.exercise || []}
              placeholder="Enter exercise goal"
              sectionKey="lifestyleChanges"
              nestedKey="exercise"
              onAdd={addNestedField}
              onChange={handleNestedChange}
              onRemove={removeNestedField}
                    buttontext={'+ Add Excercise Goal'}
          subtitle={''}
            />
            <Section
isViewMode={isViewMode}
              title="Stress Management"
              color="green"
              items={formData?.lifestyleChanges?.stressManagement || []}
              placeholder="Enter stress management strategy"
              sectionKey="lifestyleChanges"
              nestedKey="stressManagement"
              onAdd={addNestedField}
              onChange={handleNestedChange}
              onRemove={removeNestedField}
                    buttontext={'+ Add Strategy'}
          subtitle={''}
            />
            <Section
isViewMode={isViewMode}
              title="Safety"
       color="green"
              items={formData?.lifestyleChanges?.safety || []}
              placeholder="Enter safety measure"
              sectionKey="lifestyleChanges"
              nestedKey="safety"
              onAdd={addNestedField}
              onChange={handleNestedChange}
              onRemove={removeNestedField}
                    buttontext={'+ Add Safety Measure'}
          subtitle={''}
            />
            <Section
isViewMode={isViewMode}
              title="Smoking"
           color="green"
              items={formData?.lifestyleChanges?.smoking || []}
              placeholder="Enter smoking cessation plan or N/A"
              sectionKey="lifestyleChanges"
              nestedKey="smoking"
              onAdd={addNestedField}
              onChange={handleNestedChange}
              onRemove={removeNestedField}
                    buttontext={'+ Add Smoking Goal'}
          subtitle={''}
            />
            <Section
isViewMode={isViewMode}
              title="Other Habits"
             color="green"
              items={formData?.lifestyleChanges?.otherHabits || []}
              placeholder="Enter habit change"
              sectionKey="lifestyleChanges"
              nestedKey="otherHabits"
              onAdd={addNestedField}
              onChange={handleNestedChange}
                    buttontext={'+ Add Habit Change'}
          subtitle={''}
              onRemove={removeNestedField}
            />
          </div>
        </div>

        {/* Appointment Frequency */}
        <div
          className="border-l-4 pl-4 mb-6 rounded-md border-blue-600 bg-white shadow-sm p-4"
        >
          <h3 className="text-blue-700 font-semibold border-b border-gray-200 pb-1 mb-3">
            Frequency of Planned Future Appointments
          </h3>
          <input
            type="text"
            value={formData?.appointmentFrequency || ""}
            onChange={(e) => handleInputChange("appointmentFrequency", e.target.value)}
              disabled={isViewMode}
            placeholder="Enter number"
            className="w-full p-2 border border-gray-300 rounded-md"
          />
        </div>

        {/* Care Manager */}
        <div
          className="border-l-4 pl-4 mb-6 rounded-md border-blue-600 bg-white shadow-sm p-4"
        >
          <h3 className="text-blue-700 font-semibold border-b border-gray-200 pb-1 mb-3">
            Care Manager
          </h3>
          <p className="mb-2">
            If I need help arranging care outside this office...
          </p>
          <div className="mb-2">
            <label className="font-semibold text-gray-700">Name</label>
            <input
              type="text"
              value={formData?.careManager?.name || ""}
              onChange={(e) =>
                handleNestedInputChange("careManager", "name", e.target.value)
              }
                disabled={isViewMode}
              placeholder="Enter care manager name"
              className="w-full mt-1 p-2 border border-gray-300 rounded-md"
            />
          </div>
          <div className="mb-2">
            <label className="font-semibold text-gray-700">Phone/Email Address</label>
            <input
              type="text"
              value={formData?.careManager?.contact || ""}
              onChange={(e) =>
                handleNestedInputChange("careManager", "contact", e.target.value)
              }
                disabled={isViewMode}
              placeholder="Enter contact information"
              className="w-full mt-1 p-2 border border-gray-300 rounded-md"
            />
          </div>
          <FormControlLabel
            control={
              <Checkbox
                disabled={isViewMode}
                checked={formData?.willSendSummaries || false}
                onChange={(e) =>
                  handleInputChange("willSendSummaries", e.target.checked)
                }
              />
            }
            label="I will ask other providers to send a summary of their care to this office"
          />
        </div>

        {/* Expected Outcomes */}
        <Section
isViewMode={isViewMode}
          title="Expected Outcomes/Prognosis"
          color="green"
          items={formData?.expectedOutcomes || []}
          placeholder="Enter expected outcome"
          sectionKey="expectedOutcomes"
          onAdd={addField}
          onChange={handleChange}
          onRemove={removeField}
                buttontext={'+ Add Outcome'}
                
          subtitle={''}
        />

{/* Signatures */}
<div className="grid grid-cols-2 gap-6 mt-8">
  <div>
    <label className="font-semibold">Patient Signature:</label>
    <input
      type="text"
        disabled={isViewMode}
      value={formData?.patientSignature || ""}
      onChange={(e) => handleInputChange("patientSignature", e.target.value)}
      placeholder="Enter patient signature"
      className="w-full mt-1 p-2 border-b-2 border-gray-700 focus:outline-none"
    />
  </div>
  <div>
    <label className="font-semibold">Provider Signature:</label>
    <input
      type="text"
        disabled={isViewMode}
      value={formData?.providerSignature || ""}
      onChange={(e) => handleInputChange("providerSignature", e.target.value)}
      placeholder="Enter provider signature"
      className="w-full mt-1 p-2 border-b-2 border-gray-700 focus:outline-none"
    />
  </div>
</div>


        <p className="text-gray-500 text-sm italic mt-4">
          * Data for these sections may be imported from the patient record...
        </p>
        <p className="text-gray-500 text-sm italic text-center mt-2">
          Developed by Kenneth G. Adler, MD, MMM...
        </p>
        <ToastMessage
                message={toastMessage}
                severity={toastSeverity}
                open={openToast}
                handleClose={handleToastClose}
              ></ToastMessage>
      </Box>

    </Modal>
  );
};

// Reusable Section Component
const Section = ({
  title,
  color,
  buttontext,
  items,
  placeholder,
  sectionKey,
  subtitle,
  buttoncolor,
  nestedKey,
  onAdd,
  onChange,
  onRemove,
  children,
  isViewMode
}) => (
  <div
    className={`border-l-4 pl-4 mb-6 rounded-md border-${color}-600 bg-white shadow-sm p-4`}
  >
    <h3
      className={`text-blue-700 font-semibold  text-[20px] border-b border-gray-200 pb-1 mb-3`}
    >
      {title}
    </h3>
        <h3
      className={`text-black font-semibold  text-[17px]  pb-1 mb-3`}
    >
      {subtitle}
    </h3>
    {items.length === 0 && (
      <p className="text-gray-500 text-sm italic">No entries yet.</p>
    )}
    {items.map((item, index) => (
      <div key={index} className="flex items-center mb-2">
        <span className={`text-${color}-700 font-bold mr-2`}>•</span>
        <input
          type="text"
          value={item}
            disabled={isViewMode}
          onChange={(e) =>
            nestedKey
              ? onChange(sectionKey, nestedKey, index, e.target.value)
              : onChange(sectionKey, index, e.target.value)
          }
          className="flex-1 p-2 border border-gray-300 rounded-md"
          placeholder={placeholder}
        />
        <button
          onClick={() =>
            nestedKey
              ? onRemove(sectionKey, nestedKey, index)
              : onRemove(sectionKey, index)
          }
                disabled={isViewMode}    
          className="ml-2 bg-red-600 hover:bg-red-700 text-white px-2 py-1 text-xs rounded-md"
        >
          Remove
        </button>
      </div>
    ))}
    <button
              disabled={isViewMode}
      onClick={() => (nestedKey ? onAdd(sectionKey, nestedKey) : onAdd(sectionKey))}
      className={`bg-${color}-600 hover:bg-${color}-700 text-white px-3 py-1 rounded-md text-sm mt-2`}
    >
    {buttontext}
    </button>
    {children}
  </div>
);

export default CarePlanDetailModal;